import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        id_municipio: '',
        nombre: '',
        abreviatura: '',
        id_departamento: '',
        tarifa_interventoria: '',
        concepto_calculo: '',
        costo_ingenieria: '',
        costo_admin_obra: '',
        costo_inspector: '',
        costo_interventoria: '',
        costo_financiero: '',
        departamentosVisita: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { id_municipio, nombre, abreviatura, id_departamento, tarifa_interventoria, concepto_calculo, costo_ingenieria, costo_admin_obra, costo_inspector, costo_interventoria, costo_financiero } = this.state;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!abreviatura) { errores.push("error_abreviatura"); }
        if (!tarifa_interventoria) { errores.push("error_tarifa_interventoria"); }
        if (!concepto_calculo) { errores.push("error_concepto_calculo"); }
        if (!costo_ingenieria) { errores.push("error_costo_ingenieria"); }
        if (!costo_admin_obra) { errores.push("error_costo_admin_obra"); }
        if (!costo_inspector) { errores.push("error_costo_inspector"); }
        if (!costo_interventoria) { errores.push("error_costo_interventoria"); }
        if (!costo_financiero) { errores.push("error_costo_financiero"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            id_municipio: id_municipio,
            nombre: nombre,
            abreviatura: abreviatura,
            id_departamento: id_departamento,
            tarifa_interventoria: tarifa_interventoria,
            concepto_calculo: concepto_calculo,
            costo_ingenieria: costo_ingenieria,
            costo_admin_obra: costo_admin_obra,
            costo_inspector: costo_inspector,
            costo_interventoria: costo_interventoria,
            costo_financiero: costo_financiero
        }
        Swal.showLoading();
        authAxios.post("municipios_visitas/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }

                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Municipios Visita!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterMunicipiosVisita");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Municipios Visita!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentosVisita: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { id_municipio, nombre, abreviatura, id_departamento, departamentosVisita, tarifa_interventoria, concepto_calculo, costo_ingenieria, costo_admin_obra, costo_inspector, costo_interventoria, costo_financiero } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE MUNICIPIOS VISITA</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="id_departamento">Departamento</label>
                                                    <select name="id_departamento"
                                                        id="id_departamento"
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosVisita.map((itemDepartamentosVisita) => (
                                                                <option key={itemDepartamentosVisita.ID_DEPARTAMENTO} value={itemDepartamentosVisita.ID_DEPARTAMENTO}>{itemDepartamentosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="id_municipio">ID. Municipio</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="id_municipio" id="id_municipio" value={id_municipio} placeholder="ID. MUNICIPIO" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el ID. Municipio</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="NOMBRE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="abreviatura">Abreviatura</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_abreviatura")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="abreviatura" id="abreviatura" value={abreviatura} placeholder="ABREVIATURA" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Abreviatura</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN INTERVENTORÍA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="tarifa_interventoria">Tarifa Interventoría</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_tarifa_interventoria")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="tarifa_interventoria" id="tarifa_interventoria" value={tarifa_interventoria} placeholder="Tarifa Interventoría" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Tarifa Interventoría</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="concepto_calculo">Concepto Cálculo</label>
                                                    <select name="concepto_calculo"
                                                        id="concepto_calculo"
                                                        className={((this.verificarError("error_concepto_calculo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Concepto Cálculo</option>
                                                        <option value="1">VALOR FAVOR</option>
                                                        <option value="2">VALOR RECAUDO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Concepto Cálculo</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN COSTOS (UCAPS)</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_ingenieria">Costo Ingeniería</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_costo_ingenieria")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="costo_ingenieria" id="costo_ingenieria" value={costo_ingenieria} placeholder="Costo Ingeniería" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Ingeniería</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_admin_obra">Costo Admin. Obra</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_costo_admin_obra")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="costo_admin_obra" id="costo_admin_obra" value={costo_admin_obra} placeholder="Costo Admin. Obra" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Admin. Obra</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_inspector">Costo Inspector</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_costo_inspector")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="costo_inspector" id="costo_inspector" value={costo_inspector} placeholder="Costo Inspector" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Inspector</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_interventoria">Costo Interventoría</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_costo_interventoria")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="costo_interventoria" id="costo_interventoria" value={costo_interventoria} placeholder="Costo Interventoría" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Interventoría</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_financiero">Costo Financiero</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_costo_financiero")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="costo_financiero" id="costo_financiero" value={costo_financiero} placeholder="Costo Financiero" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Financiero</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Municipio Visita</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMunicipiosVisita"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;